import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { ServicesGrid } from '../components/ServicesGrid';
import { AboutSection } from '../components/AboutSection';
import { ProcessSection } from '../components/ProcessSection';
import { PortfolioGallery } from '../components/PortfolioGallery';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ServiceAreasSection } from '../components/ServiceAreasSection';
import { FAQSection } from '../components/FAQSection';
import { CTABanner } from '../components/CTABanner';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <main className="min-h-screen w-full font-sans selection:bg-[var(--brand-gold)] selection:text-black" data-id="element-222">
      <Header data-id="element-223" />
      <HeroSection data-id="element-224" />
      <TrustBar data-id="element-225" />
      <ServicesGrid data-id="element-226" />
      <AboutSection data-id="element-227" />
      <ProcessSection data-id="element-228" />
      <PortfolioGallery data-id="element-229" />
      <TestimonialsSection data-id="element-230" />
      <ServiceAreasSection data-id="element-231" />
      <FAQSection data-id="element-232" />
      <CTABanner data-id="element-233" />
      <Footer data-id="element-234" />
    </main>;
}